/**
 * Forms
 */


if ($('html').attr('lang') == 'en-US') {

    var messages = {
        letters: {
            valid: 'Please enter only letters' 
        },
        select: {
            required: 'Please select an option.'
        },
        trim: {
            valid: 'This field is required.'
        },
        noTest: {
            valid: 'Test value is not allowed.'
        },
        realMin: {
            valid(element) {
                return `Please enter at least ${element.minLength} characters.`
            }  
        },
        phone: {
            minlength: 'Please enter 10 digits.',
            maxlength: 'Please enter 10 digits.'
        }
    };

} else if ($('html').attr('lang') == 'es-US') {


    $.extend($.validator.messages, {
        required: "Este campo es obligatorio.",
        remote: "Por favor, rellena este campo.",
        email: "Por favor, escribe una dirección de correo válida.",
        url: "Por favor, escribe una URL válida.",
        date: "Por favor, escribe una fecha válida.",
        dateISO: "Por favor, escribe una fecha (ISO) válida.",
        number: "Por favor, escribe un número válido.",
        digits: "Por favor, escribe sólo dígitos.",
        creditcard: "Por favor, escribe un número de tarjeta válido.",
        equalTo: "Por favor, escribe el mismo valor de nuevo.",
        extension: "Por favor, escribe un valor con una extensión aceptada.",
        maxlength: $.validator.format("Por favor, no escribas más de {0} caracteres."),
        minlength: $.validator.format("Por favor, no escribas menos de {0} caracteres."),
        rangelength: $.validator.format("Por favor, escribe un valor entre {0} y {1} caracteres."),
        range: $.validator.format("Por favor, escribe un valor entre {0} y {1}."),
        max: $.validator.format("Por favor, escribe un valor menor o igual a {0}."),
        min: $.validator.format("Por favor, escribe un valor mayor o igual a {0}."),
        nifES: "Por favor, escribe un NIF válido.",
        nieES: "Por favor, escribe un NIE válido.",
        cifES: "Por favor, escribe un CIF válido."
    });

    var messages = {
        select: {
            required: 'Por favor, selecciona una opción.'
        },
        phone: {
            minlength: 'Por favor, ingresa 10 digitos.',
            maxlength: 'Por favor, ingresa 10 digitos.'
        }
    }
}

$(function () {

    if ($('.js-form').length) {
        $.validator.methods.email = function (value, element) {
            return this.optional(element) || /^\b[A-Z0-9.\-_]+@[A-Z0-9.\-]+\.[A-Z]{2,}\b$/i.test(value);
        };

        jQuery.validator.addMethod('trim', function (value, element, params) {
            return value.trim() !== '';
        }, messages.trim.valid);

        jQuery.validator.addMethod('realMin', function (value, element, params) {
            return this.optional(element) || value.replaceAll(' ', '').length >= element.minLength;
        }, function (params, element) {
            return messages.realMin.valid(element);
        });

        jQuery.validator.addMethod('validLetters', function (value, element, params) {
            return this.optional(element) || (/^[a-zA-Z]+$/.test(value) && !/[^a-zA-Z]/.test(value));
        }, messages.letters.valid);

        jQuery.validator.addMethod('noTest', function (value, element, params) {
            return this.optional(element) || value.trim().toLowerCase() !== 'test';
        }, messages.noTest.valid);


        $('.js-form').each(function () {
            $(this).validate({
                errorClass: 'js-form-error',
                validClass: 'js-form-valid',
                errorPlacement: function (error, element) {
                    if (element.attr('id') == 'phone') {
                        let errorContainer = element.closest('.c-request-demo__input');
                        error.insertAfter(errorContainer);
                    } else {
                        error.insertAfter(element);
                    }
                },
                submitHandler: function (form) {
                    form.classList.add('is-loading')
                    form.submit();
                }
            });
        });

        if ($('.js-valid-select').length) {
            $('.js-valid-select').each(function () {
                $(this).rules('add', {
                    messages: {
                        required: messages.select.required
                    }
                });
            });
        }

        if ($('.js-valid-phone').length) {
            $('.js-valid-phone').each(function () {
                $(this).rules('add', {
                    required: true,
                    minlength: 12,
                    maxlength: 12,
                    messages: {
                        minlength: messages.phone.minlength,
                        maxlength: messages.phone.maxlength
                    }
                });
            });
        }

        $('.js-valid-letters, .js-valid-alpha-numeric').each(function () {
            $(this).rules('add', {
                realMin: true,
                noTest: true
            });
        });

        $('#company-name').rules('add', {
            realMin: true,
            noTest: true
        }); 

        $('#first-name').rules('add', {
            messages: {
                noTest: 'Please enter a valid name.'
            }
        }); 

        $('#last-name').rules('add', {
            messages: {
                noTest: 'Please enter a valid last name.'
            }
        }); 
    }
});